// MultiSelectField.js
import React from 'react';
import { useField } from 'formik';
import { MenuItem, FormControl, InputLabel, Select, Chip } from '@mui/material';

const MultiSelectField = ({ label, options, disabled,  ...props }) => {
    const [field, meta, helpers] = useField(props.name);

    const handleChange = (event) => {
        const { value } = event.target;
        helpers.setValue(value);
    };

    const { value } = field;

    return (
        <FormControl fullWidth>
            <InputLabel>{label}</InputLabel>
            <Select
                multiple
                value={value || []}
                disabled={disabled}
                onChange={handleChange}
                label={label}
                renderValue={(selected) => (
                    <div>
                        {selected.map((item) => (
                            <Chip key={item} label={item} />
                        ))}
                    </div>
                )}
            >
                {options.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                        {option.value} - {option.label}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
};

export default MultiSelectField;
